module.exports = __webpack_public_path__ + "static/KLAUZULA-INFORMACYJNA-RODO-24d5c146297c2995e2607041c097dec3.pdf";